import Swiper from "swiper";
import { initIntersectionObserver } from "@plugins";

class BenefitsHoverSlider {
    constructor(slider) {
        this.slider = slider;
        this.sliderContainer = this.slider.querySelector(".js-benefits-hover-container");
        this.hoverPoints = this.slider.querySelectorAll(".js-hover-point");
        this.controls = [];

        this._init();
    }

    _init() {
        this._findControls();
        this._initBenefitsHoverSlider();

        if (!window.mobileMedia) {
            this._initHoverPoints();
            this._initSliderActiveIndexChangeListener();
        }
    }

    _findControls() {
        const controls = this.slider.querySelector(".js-benefits-hover-controls");

        if (controls) {
            this.controls = {
                buttonPrev: controls.querySelector(".swiper-button-prev"),
                buttonNext: controls.querySelector(".swiper-button-next"),
                pagination: controls.querySelector(".js-swiper-pagination"),
            };
        }
    }

    _initBenefitsHoverSlider() {
        if (!this.sliderContainer) return;

        const swiperOptions = {
            initialSlide: this.sliderContainer.getAttribute("data-initial-slide") || 0,
            spaceBetween: 32,
            navigation: {
                nextEl: this.controls.buttonNext,
                prevEl: this.controls.buttonPrev,
            },
            pagination: {
                el: this.controls.pagination,
            },
            breakpoints: {
                768: {
                    allowTouchMove: false,
                },
            },
        };

        this.benefitsHoverSlider = new Swiper(this.sliderContainer, swiperOptions);
    }

    _initHoverPoints() {
        if (!this.hoverPoints) return;

        const initialSlide = this.sliderContainer.getAttribute("data-initial-slide") || 0;

        this.hoverPoints[initialSlide].classList.add("active");

        for (let i = 0; i < this.hoverPoints.length; i++) {
            this.hoverPoints[i].addEventListener("pointerenter", () => {
                this._cleanPointsActiveClases();

                this.hoverPoints[i].classList.add("active");
                this.benefitsHoverSlider.slideTo(i);
            });
        }
    }

    _cleanPointsActiveClases() {
        for (const point of this.hoverPoints) {
            point.classList.remove("active");
        }
    }

    _initSliderActiveIndexChangeListener() {
        this.benefitsHoverSlider.on("activeIndexChange", () => {
            for (let i = 0; i < this.hoverPoints.length; i++) {
                if (i === this.benefitsHoverSlider.activeIndex) {
                    const currentSlideIndex = this.benefitsHoverSlider.activeIndex;

                    this._cleanPointsActiveClases();
                    this.hoverPoints[currentSlideIndex].classList.add("active");
                }
            }
        });
    }
}

const benefitsHover = document.querySelectorAll(".js-benefits-hover");

if (benefitsHover) {
    benefitsHover.forEach((item) => {
        initIntersectionObserver(item, initBenefitsHoverSlider);
    });
}

function initBenefitsHoverSlider(slider) {
    new BenefitsHoverSlider(slider);
}
